import { PropsWithChildren } from "react";
import classes from "./FormLine.module.css";

const FormLine: React.FC<PropsWithChildren> = (props) => {
  return <div className={classes.line}>{props.children}</div>;
};

export default FormLine;
